import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({showSpinner: false})

const whiteList = ['/login', '/accountThirdPartyRecordDetail', '/accountReportMonthDetailNew','/preRecordReportMonthDetailNew'] // 白名单
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  //获取系统名称
  await store.dispatch("user/getSysName")
  document.title = getPageTitle(store.getters.sysName || '掌上学', to.meta.title, sessionStorage.getItem('inname') || "")
  //确定用户是否已登录
  const hasToken = sessionStorage.getItem('token')
  if (whiteList.indexOf(to.path) !== -1) { //当前界面是否是白名单
    next();
  } else {
    if (hasToken) { //已经登录
      if (to.path === '/welcome') { //当前界面是主页
        let roleResponse = await store.dispatch('user/getInfo');//获取用户信息
        let roles = roleResponse.funIds; //获取用户的当前角色权限id
        await store.dispatch('generateRoutes', {roles});//同步加载匹配路由
        router.addRoutes(store.getters.addRouters);//添加路由
        //获取费用红点统计数量
        await store.dispatch("user/getCostNum")
        next();
        NProgress.done()
      } else { //如果不是主页
        const name = store.getters.name; //获取当前用户登录名称
        if (name) {
          next()
        } else {
          let roleResponse = await store.dispatch('user/getInfo');
          let roles = roleResponse.funIds;
          await store.dispatch('generateRoutes', {roles});
          router.addRoutes(store.getters.addRouters);
          //获取费用红点统计数量
          await store.dispatch("user/getCostNum")
          next({...to, replace: true});//重新生成替换之前的路由
          NProgress.done()
        }
      }
    } else {
      next(`/login`)
      NProgress.done()
    }
  }
})
router.afterEach(() => {
  NProgress.done()
})

